import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isMobileMenuOpenSubject = new BehaviorSubject<boolean>(false);
  private isDesktopCollapsedSubject = new BehaviorSubject<boolean>(false);

  isMobileMenuOpen$ = this.isMobileMenuOpenSubject.asObservable();
  isDesktopCollapsed$ = this.isDesktopCollapsedSubject.asObservable();

  toggleMobileMenu() {
    this.isMobileMenuOpenSubject.next(!this.isMobileMenuOpenSubject.value);
  }

  closeMobileMenu() {
    this.isMobileMenuOpenSubject.next(false);
  }

  toggleDesktopSidebar() {
    this.isDesktopCollapsedSubject.next(!this.isDesktopCollapsedSubject.value);
  }
}